import api from "./api";

const ACCOUNT_OPTIONS_QUERY = /* GraphQL */ `
  query AccountOptions($email: String!) {
    accountOptions(email: $email) {
      accountId
      accountType
      name
      userId
      accountLogo
      userLogo
      accountPrimaryColor
      companyName
      memberSince
      role
      totalReports
      lastReportTitle
      lastReportCreatedAt
      platformSignInRequired
    }
  }
`;

function postGraphql(body) {
  return api.post("/graphql", body).then((response) => {
    const { data, errors } = response.data || {};
    if (errors && errors.length) {
      throw new Error(errors[0].message || "GraphQL request failed");
    }
    return data || {};
  });
}

export function fetchAccountOptions(email) {
  return postGraphql({
    query: ACCOUNT_OPTIONS_QUERY,
    variables: { email }
  }).then((data) => data.accountOptions || []);
}
